import { render } from "./PhoneNumber.vue?vue&type=template&id=68ea9b8c"
import script from "./PhoneNumber.vue?vue&type=script&lang=js"
export * from "./PhoneNumber.vue?vue&type=script&lang=js"

import "./PhoneNumber.vue?vue&type=style&index=0&id=68ea9b8c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__